'use strict';
import AkrisUpdateUserRequest from "../../../models/akrisUpdateUserRequest";
var SettingsController = /** @class */ (function () {
    /*@ngInject*/
    function SettingsController($scope, $q, Auth, $window, $cookies, SettingsService, $mdToast, Util, GeneralInfoEditService, ProfessionalInfoService, AddressService, RxCredentialListService, CredentialListService, googleAnalytic, SettingsEvents, seoMetaService) {
        var _this = this;
        this.errors = {
            other: undefined
        };
        this.message = '';
        this.submitted = false;
        this.allPromises = [];
        this.audience = 'resale';
        var self = this;
        self.$cookies = $cookies;
        self.$window = $window;
        this.Auth = Auth;
        self.isImpersonated = false;
        this.settingsService = SettingsService;
        this.addrSvc = AddressService;
        this.generalInfo = GeneralInfoEditService;
        this.pinfoService = ProfessionalInfoService;
        this.$scope = $scope;
        this.$q = $q;
        this.$mdToast = $mdToast;
        this.Util = Util;
        this.RxCredentialListService = RxCredentialListService;
        this.CredentialListService = CredentialListService;
        this.mode = 'edit';
        this.rxCredsExist = false;
        this.GoogleAnalyticsService = googleAnalytic;
        this.settingsEvents = SettingsEvents;
        SettingsService.isGinfoFormValid = true;
        SettingsService.isAddressValid = true;
        SettingsService.isFormPristine = true;
        SettingsService.isPinfoFormValid = true;
        this.rxStateChange = false;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'SettingsController');
        this.RxCredentialListService.getCredentials()
            .then(function (cred) {
            _this.credentials = cred.data;
            for (var i = 0; i < _this.credentials.length; i++) {
                if (_this.credentials[i].dispense && _this.credentials[i].prescribe) {
                    _this.rxCredsExist = true;
                    break;
                }
            }
        });
        this.rxConfig = {};
        this.rxConfig.disableSaveButton = false;
    }
    SettingsController.prototype.$onInit = function () {
        var self = this;
        self.getUserAccount();
        self.isValidForm();
    };
    ;
    SettingsController.prototype.$onDestroy = function () {
        if (this.getAkrisUserProfileSub && !this.getAkrisUserProfileSub.closed) {
            this.getAkrisUserProfileSub.unsubscribe();
        }
    };
    ;
    SettingsController.prototype.getUserAccount = function () {
        var self = this;
        this.settingsService.getAccount().then(function (newAccount) {
            self.isImpersonated = newAccount.isImpersonated;
            self.getAkrisUserProfileSub = self.Auth.getAkrisUserProfile().subscribe(function (akrisUserInfo) {
                var user = self.getUser(newAccount);
                self.user = self.useAkrisUserInfo(user, akrisUserInfo);
                self.pinfo = self.getPinfo(self.user);
                if (self.user.accountType == 'Practitioner') {
                    self.audience = 'resale';
                }
                else {
                    self.audience = 'personal';
                }
                self.settingsService.pinfoAddress = self.pinfo.billingAddress;
                self.originalState = self.pinfo.billingAddress.regionCode;
                self.settingsService.pinfoUser = self.user;
                self.settingsService.pinfoCustomerId = self.pinfo.customerId;
                self.settingsService.ginfoNewAccount = self.user;
                self.settingsService.ginfoCustomerId = self.user.customerId;
            });
        })
            .catch(function (flag) {
            self.$cookies.put('eeprevurl', self.$window.location.pathname);
            self.$window.location = 'auth/ares';
        });
    };
    SettingsController.prototype.useAkrisUserInfo = function (aresUser, akrisUser) {
        if (akrisUser.given_name !== null && akrisUser.given_name !== '') {
            aresUser.firstName = akrisUser.given_name;
        }
        if (akrisUser.family_name !== null && akrisUser.family_name !== '') {
            aresUser.lastName = akrisUser.family_name;
        }
        aresUser.middleInitial = akrisUser.middle_name;
        aresUser.title = akrisUser.title;
        aresUser.suffix = akrisUser.suffix;
        if (akrisUser.phone_number !== null && akrisUser.phone_number !== '') {
            aresUser.phone = akrisUser.phone_number;
        }
        return aresUser;
    };
    SettingsController.prototype.changePassword = function (form) {
        var _this = this;
        this.submitted = true;
        if (form.$valid) {
            this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
                .then(function () {
                _this.message = 'Password successfully changed.';
            })
                .catch(function () {
                form.password.$setValidity('mongoose', false);
                _this.errors.other = 'Incorrect password';
                _this.message = '';
            });
        }
    };
    SettingsController.prototype.updateForm = function () {
        if (this.rxConfig.newState && this.rxConfig.newState.regionCode != this.rxConfig.oldState && !this.rxConfig.canDeleteCredentials) {
            this.validCredentials = this.credentials;
            if (this.validCredentials.length) {
                for (var cred in this.validCredentials) {
                    if (this.validCredentials[cred]['prescribe'] == 'Approved') {
                        this.rxConfig.canDeleteCredentials = true;
                        break;
                    }
                }
            }
        }
        if (this.rxConfig.canDeleteCredentials) {
            this.deleteMatchedCredentials();
        }
        var self = this;
        var oldEmail = self.settingsService.pinfoUser.email;
        var updatedUserData = new AkrisUpdateUserRequest();
        updatedUserData.firstName = self.settingsService.pinfoUser.firstName = self.settingsService.ginfoNewAccount.firstName;
        updatedUserData.lastName = self.settingsService.pinfoUser.lastName = self.settingsService.ginfoNewAccount.lastName;
        self.settingsService.pinfoUser.email = self.settingsService.ginfoNewAccount.email;
        if (this.isImpersonated) {
            updatedUserData.emailAddress = self.settingsService.pinfoUser.email;
        }
        else {
            updatedUserData.emailAddress = oldEmail;
        }
        updatedUserData.title = self.settingsService.pinfoUser.title = self.settingsService.ginfoNewAccount.title;
        updatedUserData.suffix = self.settingsService.pinfoUser.suffix = self.settingsService.ginfoNewAccount.suffix;
        updatedUserData.middleName = self.settingsService.pinfoUser.middleInitial = self.settingsService.ginfoNewAccount.middleInitial;
        self.settingsService.pinfoUser.professionalDesignations = self.settingsService.ginfoNewAccount.professionalDesignations;
        if (self.settingsService.pinfoUser.phoneNumberExt == undefined) {
            self.settingsService.pinfoUser.phoneNumberExt = self.pinfo.ext;
        }
        if (self.settingsService.pinfoUser.password != self.settingsService.ginfoNewAccount.password) {
            // Analytics - GTM Integration
            var eventData = self.settingsEvents.practitionerSettingsEvents['resetPasswordRequest'];
            self.GoogleAnalyticsService.sendGTMEvent(eventData, {
                practitionerId: self.settingsService.pinfoUser.customerId
            });
        }
        self.settingsService.pinfoUser.password = self.settingsService.ginfoNewAccount.password;
        if (self.user.accountType == 'Patient') {
            self.settingsService.pinfoUser.phoneNumberExt = self.settingsService.ginfoNewAccount.phoneNumberExt;
        }
        if (self.settingsService.pinfoUser.phoneNumber == undefined) {
            updatedUserData.phoneNumber = self.settingsService.pinfoUser.phoneNumber = self.settingsService.ginfoNewAccount.phoneNumber;
        }
        else {
            updatedUserData.phoneNumber = self.settingsService.pinfoUser.phoneNumber;
        }
        if (self.settingsService.pinfoUser.professionalDesignations == undefined) {
            self.settingsService.pinfoUser.professionalDesignations = self.user.designation;
        }
        if (self.settingsService.pinfoUser.faxNumber == undefined || self.settingsService.pinfoUser.faxNumber === "") {
            self.settingsService.pinfoUser.faxNumber = self.pinfo.fax;
        }
        var fullName = updatedUserData.title + ' ' +
            updatedUserData.firstName + ' ' +
            updatedUserData.middleName + ' ' +
            updatedUserData.lastName + ' ' +
            updatedUserData.suffix;
        updatedUserData.fullName = fullName.replace(/\s+/g, ' ').trim();
        var tmpUserData = JSON.parse(JSON.stringify(self.settingsService.pinfoUser));
        delete tmpUserData['email']; //This needs to be removed due to the fact that all of these services check for an existing email. Removing this here allows the value to be updated in Akris and the ETl will deal with propagating the change to the other databases
        self.pinfoService.updateAccount(self.settingsService.pinfoCustomerId, tmpUserData).then(function (pInfoRes) {
            if (pInfoRes.status != 200 || (pInfoRes.data && pInfoRes.data.errors && pInfoRes.data.errors.length)) {
                self.Util.handleApiError(pInfoRes, self);
            }
            else {
                self.Auth.updateAkrisUser(updatedUserData).toPromise().then(function (akrisRes) {
                    if (akrisRes.status != 200 || (akrisRes.data && akrisRes.data.errorMessage)) {
                        akrisRes.data.errors = [akrisRes.data.errorMessage];
                        self.Util.handleApiError(akrisRes, self);
                    }
                    else {
                        self.addrSvc.updateAddress(self.settingsService.pinfoAddress).then(function (addrSvcRes) {
                            if (addrSvcRes.status != 200 || (pInfoRes.data && pInfoRes.data.errors && pInfoRes.data.errors.length)) {
                                self.Utill.handleApiError(addrSvcRes, self);
                            }
                            else {
                                self.$scope.$emit('updatedAddress', self.settingsService.pinfoAddress);
                                self.$mdToast.show(self.$mdToast.simple()
                                    .textContent('Changes have been saved.')
                                    .hideDelay(2000)
                                    .position('top right'));
                                self.Util.resetApiError(self);
                            }
                        });
                        if (oldEmail !== self.settingsService.ginfoNewAccount.email) {
                            setTimeout(function () {
                                self.Auth.refreshToken()
                                    .then(function () { return self.Auth.getCurrentUser(undefined); })
                                    .then(function (r) { return self.Auth.setCurrentUser(r); });
                            }, 5000);
                        }
                    }
                });
            }
        });
    };
    SettingsController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#prof-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    SettingsController.prototype.isValidForm = function () {
        var self = this;
        if (self.settingsService.isGinfoFormValid && self.settingsService.isAddressValid && !self.settingsService.isFormPristine && self.settingsService.isPinfoFormValid && !self.rxConfig.disableSaveButton) {
            if (!self.rxCredsExist) {
                return false;
            }
            if (self.originalState == self.pinfo.billingAddress.regionCode || self.rxStateChange) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    SettingsController.prototype.getPinfo = function (user) {
        var newPinfo = {};
        newPinfo.customerId = user.customerId;
        newPinfo.customerKey = user.customerKey;
        newPinfo.businessName = user.businessName;
        newPinfo.businessPhone = user.phone;
        newPinfo.ext = user.ext;
        newPinfo.fax = user.fax;
        newPinfo.billingAddress = {};
        newPinfo.billingAddress.addressKey = user.billingAddress.addressKey;
        newPinfo.billingAddress.recipientName = user.billingAddress.recipientName;
        newPinfo.billingAddress.firstName = user.billingAddress.firstName;
        newPinfo.billingAddress.lastName = user.billingAddress.lastName;
        newPinfo.billingAddress.line1 = user.billingAddress.line1;
        newPinfo.billingAddress.line2 = user.billingAddress.line2;
        newPinfo.billingAddress.city = user.billingAddress.city;
        newPinfo.billingAddress.regionCode = user.billingAddress.regionCode;
        newPinfo.billingAddress.regionName = user.billingAddress.regionName;
        newPinfo.billingAddress.postalCode = user.billingAddress.postalCode;
        newPinfo.billingAddress.countryCode = user.billingAddress.countryCode;
        newPinfo.billingAddress.countryName = user.billingAddress.countryName;
        newPinfo.billingAddress.phoneNumber = user.billingAddress.phoneNumber;
        newPinfo.billingAddress.phoneNumberExt = user.billingAddress.phoneNumberExt;
        newPinfo.billingAddress.addressType = user.billingAddress.addressType;
        newPinfo.billingAddress.isDefault = user.billingAddress.isDefault;
        return newPinfo;
    };
    SettingsController.prototype.getUser = function (user) {
        var newAccount = {};
        newAccount.customerId = user.customerId;
        newAccount.customerKey = user.customerKey;
        newAccount.businessName = user.businessName;
        newAccount.email = user.email;
        if (user.billingAddress) {
            newAccount.billingAddress = {};
            newAccount.billingAddress.addressKey = user.billingAddress.addressKey;
            newAccount.billingAddress.recipientName = user.billingAddress.recipientName;
            newAccount.billingAddress.firstName = user.billingAddress.firstName;
            newAccount.billingAddress.lastName = user.billingAddress.lastName;
            newAccount.billingAddress.line1 = user.billingAddress.line1;
            newAccount.billingAddress.line2 = user.billingAddress.line2;
            newAccount.billingAddress.city = user.billingAddress.city;
            newAccount.billingAddress.regionCode = user.billingAddress.regionCode;
            newAccount.billingAddress.regionName = user.billingAddress.regionName;
            newAccount.billingAddress.postalCode = user.billingAddress.postalCode;
            newAccount.billingAddress.countryCode = user.billingAddress.countryCode;
            newAccount.billingAddress.countryName = user.billingAddress.countryName;
            newAccount.billingAddress.phoneNumber = user.billingAddress.phoneNumber;
            newAccount.billingAddress.phoneNumberExt = user.billingAddress.phoneNumberExt;
            newAccount.billingAddress.addressType = user.billingAddress.addressType;
            newAccount.billingAddress.isDefault = user.billingAddress.isDefault;
        }
        else {
            newAccount.billingAddress = user.billingAddress;
        }
        if (user.defaultShippingAddress) {
            newAccount.defaultShippingAddress = {};
            newAccount.defaultShippingAddress.recipientName = user.defaultShippingAddress.recipientName;
            newAccount.defaultShippingAddress.addressKey = user.defaultShippingAddress.addressKey;
            newAccount.defaultShippingAddress.line1 = user.defaultShippingAddress.line1;
            newAccount.defaultShippingAddress.line2 = user.defaultShippingAddress.line2;
            newAccount.defaultShippingAddress.city = user.defaultShippingAddress.city;
            newAccount.defaultShippingAddress.regionCode = user.defaultShippingAddress.regionCode;
            newAccount.defaultShippingAddress.regionName = user.defaultShippingAddress.regionName;
            newAccount.defaultShippingAddress.postalCode = user.defaultShippingAddress.postalCode;
            newAccount.defaultShippingAddress.countryCode = user.defaultShippingAddress.countryCode;
            newAccount.defaultShippingAddress.countryName = user.defaultShippingAddress.countryName;
            newAccount.defaultShippingAddress.phoneNumber = user.defaultShippingAddress.phoneNumber;
            newAccount.defaultShippingAddress.phoneNumberExt = user.defaultShippingAddress.phoneNumberExt;
        }
        else {
            newAccount.defaultShippingAddress = user.defaultShippingAddress;
        }
        newAccount.password = user.password;
        newAccount.phone = user.phoneNumber;
        newAccount.ext = user.phoneNumberExt;
        newAccount.fax = user.faxNumber;
        newAccount.faxNumberExt = '';
        newAccount.accountType = user.accountType;
        newAccount.firstName = user.firstName;
        newAccount.middleInitial = user.middleInitial;
        newAccount.lastName = user.lastName;
        newAccount.title = user.title;
        newAccount.suffix = user.suffix;
        newAccount.designation = user.professionalDesignations;
        return newAccount;
    };
    SettingsController.prototype.deleteMatchedCredentials = function () {
        var credentialArray = [];
        for (var cred in this.validCredentials) {
            if (this.rxConfig.newState && this.rxConfig.newState.regionCode != this.rxConfig.oldState && this.validCredentials[cred]['prescribe'] === 'Approved') {
                credentialArray.push(this.validCredentials[cred]);
            }
        }
        if (credentialArray.length) {
            for (var cred in credentialArray) {
                this.CredentialListService.deleteCredential(credentialArray[cred]['credentialId']);
            }
        }
        this.rxConfig.canDeleteCredentials = false;
    };
    SettingsController.prototype.canDeleteCheck = function () {
        var self = this;
        if (self.rxStateChange) {
            self.rxConfig.disableSaveButton = false;
            self.rxConfig.canDeleteCredentials = false;
        }
        else {
            self.rxConfig.disableSaveButton = true;
        }
    };
    return SettingsController;
}());
export default SettingsController;
//# sourceMappingURL=settings.controller.js.map